






import { Component, Vue, Emit } from "vue-property-decorator";
import store from "@/store";
@Component
export default class Game extends Vue {
    @Emit()
    newGame() {
        let gameBox = Array.from(Array(4)).map(() => Array(4).fill(undefined));
        let x = Math.floor(Math.random() * 4);
        let y = Math.floor(Math.random() * 4);
        this.$store.state.gameBox[x][y] = Math.random() < 0.9 ? 2 : 4;
        store.commit("setGameBox", gameBox);
        store.commit("initScore");
        localStorage.setItem("gameBox", JSON.stringify(gameBox));
    }
}
